import { render } from "./sourcing-event-detail.vue?vue&type=template&id=066dd6db&scoped=true"
import script from "./sourcing-event-detail.vue?vue&type=script&lang=js"
export * from "./sourcing-event-detail.vue?vue&type=script&lang=js"

import "./sourcing-event-detail.vue?vue&type=style&index=0&id=066dd6db&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066dd6db"]])

export default __exports__